// web-push generates VAPID keys as base64 with trailing "=" padding, but
// Chrome's pushManager.subscribe rejects padded strings ("applicationServerKey
// is not encoded as base64url without padding") — which made every push
// enrollment fail silently. Decoding to a Uint8Array sidesteps the string
// format rules entirely and works in every browser.
export function vapidApplicationServerKey(key) {
    const base64 = key.replace(/-/g, "+").replace(/_/g, "/").replace(/=+$/, "")
    const padded = base64 + "=".repeat((4 - (base64.length % 4)) % 4)
    const raw = atob(padded)
    const bytes = new Uint8Array(raw.length)
    for (let i = 0; i < raw.length; i += 1) bytes[i] = raw.charCodeAt(i)
    return bytes
}
